"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { getBackgroundColor } from "../../../../utils/color.js";
import { SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { ImageVideo } from "../../ImageVideo/index.js";
import { getFirstMediaAssets } from "../../ImageVideo/lib.js";
import { dynamicImagePlacement } from "../util.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { useCheckScreen } from "../../../../hooks/useCheckScreen/index.js";
import { MarkdownWithInlineImages } from "./MarkdownWithInlineImages.js";
import { imageWrapperStyle, StyledHeader, mobileImageStyle, imageStyle } from "./styles.js";
const StaticHeaderBlock = ({
  entryData,
  sx,
  locale
}) => {
  const { isMobile, isTablet } = useCheckScreen();
  const { header_content, header_image, header_config } = entryData;
  const {
    image_placement,
    image,
    use_mobile_image_variant,
    image_alt_text,
    mobile_image_variant
  } = header_image;
  const { mobile_image, use_mobile_image_alt_text, mobile_image_alt_text } = mobile_image_variant;
  const leadingImage = image_placement === "leading";
  const trailingImage = image_placement === "trailing";
  const imagePlacement = dynamicImagePlacement(
    header_image == null ? void 0 : header_image.enable_dynamic_row_config,
    header_image == null ? void 0 : header_image.dynamic_row_config,
    header_image == null ? void 0 : header_image.image_type,
    isMobile,
    isTablet
  );
  const headerBackgroundColor = getBackgroundColor(
    header_config == null ? void 0 : header_config.background_color
  );
  const backgroundImageFirstObjUrl = Array.isArray(image) && image[0] ? image[0].url : void 0;
  const mergedImageSx = { ...sx, ...imageStyle };
  const mergedMobileImageSx = { ...sx, ...mobileImageStyle };
  const wrapperSx = [
    ...Array.isArray(sx) ? sx : [sx],
    ...Array.isArray(imageWrapperStyle) ? imageWrapperStyle : [imageWrapperStyle]
  ].filter((styleObj) => styleObj != null);
  const { firstImage } = getFirstMediaAssets(image);
  let firstMobileImage = void 0;
  if (isMobile && mobile_image) {
    const result = getFirstMediaAssets(mobile_image);
    firstMobileImage = typeof (result == null ? void 0 : result.firstImage) === "string" ? result.firstImage : void 0;
  }
  const isImage = !!firstImage;
  const isMobileImage = isMobile && !!firstMobileImage;
  return /* @__PURE__ */ jsxs(StyledHeader, { backgroundColor: headerBackgroundColor, children: [
    leadingImage && /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: {
          display: "flex",
          flexBasis: `calc(${imagePlacement}% - 56px)`,
          flexDirection: "column",
          flexGrow: "1",
          paddingRight: imagePlacement !== 100 && SpaceLg
        },
        children: /* @__PURE__ */ jsx(
          CostcoBox,
          {
            sx: isImage || isMobileImage ? { borderRadius: "10px", overflow: "hidden" } : {},
            children: /* @__PURE__ */ jsx(
              ImageVideo,
              {
                enableMobileImageVariation: use_mobile_image_variant,
                image,
                imageUrl: backgroundImageFirstObjUrl,
                imageAltText: image_alt_text,
                imageSx: mergedImageSx,
                locale,
                mobileImage: mobile_image,
                mobileImageAltText: mobile_image_alt_text,
                mobileImageSx: mergedMobileImageSx,
                sx: wrapperSx,
                useMobileImageAltText: use_mobile_image_alt_text
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      MarkdownWithInlineImages,
      {
        headerConfig: header_config,
        headerContent: header_content,
        imagePlacement
      }
    ),
    trailingImage && /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: {
          display: "flex",
          flexBasis: `calc(${imagePlacement}% - 56px)`,
          flexDirection: "column",
          flexGrow: "1",
          paddingLeft: imagePlacement !== 100 && SpaceLg
        },
        children: /* @__PURE__ */ jsx(
          CostcoBox,
          {
            sx: isImage || isMobileImage ? { borderRadius: "10px", overflow: "hidden" } : {},
            children: /* @__PURE__ */ jsx(
              ImageVideo,
              {
                enableMobileImageVariation: use_mobile_image_variant,
                image,
                imageUrl: backgroundImageFirstObjUrl,
                imageAltText: image_alt_text,
                imageSx: mergedImageSx,
                locale,
                mobileImage: mobile_image,
                mobileImageAltText: mobile_image_alt_text,
                mobileImageSx: mergedMobileImageSx,
                sx: wrapperSx,
                useMobileImageAltText: use_mobile_image_alt_text
              }
            )
          }
        )
      }
    )
  ] });
};
export {
  StaticHeaderBlock
};
